import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Container, Grid, GridColumn, Icon, Button, Accordion} from "semantic-ui-react";
import MobileApplyNow from "./common/MobileApplyNow";
import ApplyNow from "./common/ApplyNow";
import * as faqActions from "../store/faq/faqActions";
import handleApplyEntry from "./common/handleApplyEntry";
import { withRouter } from "react-router-dom";


class FAQs extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    page: PropTypes.object,
    season: PropTypes.object.isRequired,
    getFaq: PropTypes.func.isRequired,
    faq: PropTypes.array.isRequired,
  };

  static defaultProps = {
    page: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1,
      visible: false,
    };
  }

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  handleApplyClick = () => {
    handleApplyEntry({
      show: this.props.show,
      history: this.props.history,
      openApplySidebar: this.toggleVisibility
    });
  };

  closeMenu = () => this.setState({ visible: false });

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.page.externalIdC) {
      this.props.getFaq(this.props.page.externalIdC);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.page.externalIdC &&
      prevProps.page.externalIdC !== this.props.page.externalIdC
    ) {
      this.props.getFaq(this.props.page.externalIdC);
    }
  }

  handleFaqClick = index => {
    if (index === this.state.activeIndex) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: index });
    }
  };

  renderTips(tips) {
    return (
      <GridColumn className="ui sixteen wide mobile five wide computer right floated tablet-up">
        <div className="ui fluid card noShadow tip">
          <div
            className="content invertedPrimary"
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <div className="header">
              <h4>Tip</h4>
            </div>
          </div>
          <div
            className="content shaded padded"
            dangerouslySetInnerHTML={{ __html: tips }}
          />
        </div>
      </GridColumn>
    );
  }

  renderQuestions(faqs) {
    const { activeIndex } = this.state;
    return (
      <div className="column ui sixteen wide">
        <div className="ui sixteen wide column">
          <Accordion className="styled fluid largeIcon">
            {faqs.map((faq, i) => (
              <React.Fragment key={i}>
                <Accordion.Title
                  active={activeIndex === i}
                  index={i}
                  onClick={() => this.handleFaqClick(i)}
                  style={
                    activeIndex === i
                      ? { color: `#${this.props.season.hexColorCodeC}` }
                      : {}
                  }
                >
                  {faq.questionC}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === i}>
                  <p>{faq.answerC}</p>
                </Accordion.Content>
              </React.Fragment>
            ))}
          </Accordion>
        </div>
      </div>
    );
  }

  fixPageContent(pageContent) {
    pageContent = pageContent.split("target=\"_blank\"");

    for (let content in pageContent) {
      if (pageContent.length !== parseInt(content) + 1 && !pageContent[content].includes("mailto:")) {
        pageContent[content] += "target=\"_blank\"";
      }
    }

    return pageContent.join();
  }

  render() {
    const { show, page, season } = this.props;
    const tips = page && page.tipsC ? this.renderTips(page.tipsC) : '';
    let pageContent = '';
    if (page && page.pageContentC) {
      pageContent = this.fixPageContent(page.pageContentC);
    }
    const IsGermanShoreShow = process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';

    if (page) {
      return (
        <div>
          <Container id="mainContent" className="ui">
            <Grid className="ui">
              <GridColumn className="pageShowTitle">
                <h3
                  className="ui dividing header"
                  style={{ color: `#${season.hexColorCodeC}` }}
                >
                  {show.name} Casting
                </h3>
                <Button
                  onClick={this.handleApplyClick}
                  id="applyToggle"
                  className="tiny ui primary tablet-down mobileToggle"
                >
                  <Icon className="sidebar" />
                  {IsGermanShoreShow ? "Bewirb dich jetzt" : "Apply Now"}
                </Button>
              </GridColumn>
            </Grid>

            <MobileApplyNow
              season={season}
              visible={this.state.visible}
              onApply={this.handleApplyClick} />

            <Grid className="ui stackable" onClick={this.closeMenu}>
              <GridColumn className="ui sixteen wide mobile eight wide computer">
                <h1>{page.pageTitleC}</h1>

                <p>{page.leadParagraphC}</p>

                <style>{"\
                .inner-html a {\
                  color:#" + season.hexColorCodeC + " !important;\
                }\
              "}</style>

                <div className="inner-html" dangerouslySetInnerHTML={{ __html: pageContent}} />

                <div className="ui hidden padded divider" />
              </GridColumn>

              <ApplyNow
                season={this.props.season}
                show={this.props.show}
                onApply={this.handleApplyClick}
              />

              {tips}
              {this.renderQuestions(this.props.faq)}
            </Grid>
          </Container>
        </div>
      );
    }
    return <div />;
  }
}

const mapStatesToProps = state => ({
  faq: state.faq.faq,
  loading: state.faq.loading,
});

const mapDispatchToProps = dispatch => ({
  getFaq: faqId => dispatch(faqActions.getFaq(faqId)),
});

export default withRouter(connect(mapStatesToProps, mapDispatchToProps)(FAQs));



// WEBPACK FOOTER //
// ./src/components/FAQs.js